// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarChart_wrapper__3LEwb","wrapperChart":"BarChart_wrapperChart__3ujIf","yAxies":"BarChart_yAxies__3IZbF","yAxiesSP":"BarChart_yAxiesSP__2Ww39"};